// extracted by mini-css-extract-plugin
export default {"codeBox":"InstallTrackingCode_codeBox__uz+WX","copyIcon":"InstallTrackingCode_copyIcon__FuBOD"};